export const initAudkenni = async (
  authType: string,
  externalId: string,
  phoneNumber: string,
): Promise<{ id: string; code: string }> => {
  const url = `/api/auth/authkenni`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        authType,
        externalId,
        phoneNumber,
      }),
    });
    if (!resp.ok) {
      throw resp;
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getPayment exception: ${error}`);
    throw error;
  }
};

export const GetAuthUserStatus = async (
  session: string,
): Promise<{ status: string }> => {
  const url = `/api/auth/status/${session}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`GetAuthUserStatus exception: ${error}`);
    throw error;
  }
};
